import moment from "moment";
import React, { Component } from "react";
import { confirmAlert } from "react-confirm-alert";
import AddEditMcc from "../modals/mcc/add-edit-mcc";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./mcc-list.scss";
import { MccListWithPaginate, RemoveMcc } from "../../api";
import Loader from "../loader/loader";
import ReactPaginate from "react-paginate";
import { getAlertPopUp } from "../helper/helper";

class MccList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddEditModel: false,
            mccList: {},
            searchValue: "",
            selectedMccRecord: {},
            showSpinner: true,
            totalMcc: 0,
            page: 1,
            sortBy: "id",
            sortColumn: "ASC",
        };
    }
    componentDidMount() {
        this.GetMccList();
    }

    handleShowModel = () => {
        this.setState({ selectedMccRecord: undefined }, () => {
            this.setState({ showAddEditModel: true });
        });
    };

    GetMccList() {
        const searchTerm = {
            search: this.state.searchValue,
            sortBy: this.state.sortBy,
            sortColumn: this.state.sortColumn,
        };
        MccListWithPaginate(this.state.page, searchTerm)
            .then((response) => {
                if (response.success === true) {
                    this.setState({
                        mccList: response.data.data,
                        totalMcc: response.data.total,
                        showSpinner: false,
                    });
                } else {
                    this.setState({ mccList: {}, showSpinner: false });
                }
            })
            .catch((error) => console.log(error));
    }

    handleKeyWordChange = (evt) => {
        this.setState({ searchValue: evt.target.value }, () => {
            this.GetMccList();
        });
    };

    handleSearchClick = (evt) => {
        if (this.state.searchValue !== "") this.GetMccList();
    };

    editRecord(data) {
        this.setState({ selectedMccRecord: data }, () => {
            this.setState({ showAddEditModel: true });
        });
    }

    sortData = (SortBy) => {
        let SortValue = this.state.sortColumn;
        if (this.state.sortBy == SortBy) {
            SortValue = SortValue == "DESC" ? "ASC" : "DESC";
        } else {
            SortValue = "ASC";
        }
        this.setState({ sortBy: SortBy, sortColumn: SortValue }, function () {
            this.GetMccList();
        });
    };

    handleMccDelete = (evt) => {
        confirmAlert({
            title: "Delete Record",
            message: "Are you sure you want to delete the record?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        this.deleteRecord(evt);
                        this.setState({ searchValue: "" });
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };
    deleteRecord(data) {
        RemoveMcc(data.id)
            .then((response) => {
                if (response.success) {
                    this.GetMccList();
                    const popup = {
                        title: "Success!",
                        html: "Record removed successfully",
                    };
                    getAlertPopUp(popup);
                } else {
                    const popup = {
                        title: "Error!",
                        html: response.message,
                        error: true,
                    };
                    getAlertPopUp(popup);
                }
            })
            .catch((error) => console.log(error));
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ page: selected + 1 }, () => {
            this.GetMccList();
        });
    };

    render() {
        const { showAddEditModel, searchValue, mccList, sortBy, sortColumn } =
            this.state;
        return (
            <>
                <div className="container-fluid mcc-container">
                    {showAddEditModel === true && (
                        <AddEditMcc
                            showAddEditModel={showAddEditModel}
                            handleCloseModel={() =>
                                this.setState({ showAddEditModel: false })
                            }
                            show={showAddEditModel}
                            GetMccList={() => this.GetMccList()}
                            selectedMccRecord={this.state.selectedMccRecord}
                        />
                    )}
                    <div className="panel-heading" id="pannel-headingId">
                        <div className="d-flex">
                            <h4>
                                Mcc{" "}
                                <span>{"(" + this.state.totalMcc + ")"}</span>
                            </h4>
                            <button
                                onClick={(evt) => this.handleShowModel()}
                                className="orgbtn"
                            >
                                <i className="fa fa-create"></i> Add Mcc
                            </button>
                        </div>
                        <div className="header-search">
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                }}
                            >
                                <input
                                    value={searchValue}
                                    type="text"
                                    placeholder="Search"
                                    name="search"
                                    className="search-box"
                                    onChange={(evt) =>
                                        this.handleKeyWordChange(evt)
                                    }
                                />
                                <button
                                    onClick={(e) => this.handleSearchClick(e)}
                                    type="button"
                                >
                                    {" "}
                                    <i className="fa fa-search"></i>{" "}
                                </button>
                            </form>
                        </div>
                    </div>

                    <div className="table-organizations table-templates mcc-table">
                        {mccList && mccList.length > 0 ? (
                            <div>
                                <table
                                    className="table table-striped table-responsive template-list"
                                    id="template-index-table"
                                >
                                    <thead>
                                        <tr>
                                            <th
                                                onClick={(e) =>
                                                    this.sortData("id")
                                                }
                                                className="Title"
                                            >
                                                {" "}
                                                ID{" "}
                                                {sortBy === "id" && (
                                                    <i
                                                        className={
                                                            sortColumn === "ASC"
                                                                ? "fa fa-arrow-up"
                                                                : "fa fa-arrow-down"
                                                        }
                                                        aria-hidden="true"
                                                    />
                                                )}{" "}
                                            </th>
                                            <th
                                                onClick={(e) =>
                                                    this.sortData("mcc")
                                                }
                                                className="Title"
                                            >
                                                {" "}
                                                MCC{" "}
                                                {sortBy === "mcc" && (
                                                    <i
                                                        className={
                                                            sortColumn === "ASC"
                                                                ? "fa fa-arrow-up"
                                                                : "fa fa-arrow-down"
                                                        }
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </th>
                                            <th
                                                onClick={(e) =>
                                                    this.sortData("category")
                                                }
                                                className="Title"
                                            >
                                                {" "}
                                                Category{" "}
                                                {sortBy === "category" && (
                                                    <i
                                                        className={
                                                            sortColumn === "ASC"
                                                                ? "fa fa-arrow-up"
                                                                : "fa fa-arrow-down"
                                                        }
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </th>
                                            <th
                                                onClick={(e) =>
                                                    this.sortData("description")
                                                }
                                                className="Title"
                                            >
                                                {" "}
                                                Description{" "}
                                                {sortBy === "description" && (
                                                    <i
                                                        className={
                                                            sortColumn === "ASC"
                                                                ? "fa fa-arrow-up"
                                                                : "fa fa-arrow-down"
                                                        }
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </th>
                                            <th className="Title">
                                                {" "}
                                                Risk Type{" "}
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mccList.map((data, index) => (
                                            <tr key={"tr" + index}>
                                                <td className="mccID">
                                                    <div className="org-full-name">
                                                        <h4>{data.id}</h4>
                                                    </div>
                                                </td>
                                                <td className="mcc">
                                                    <div className="org-full-name">
                                                        <h4>{data.mcc}</h4>
                                                    </div>
                                                </td>
                                                <td className="mccCategory">
                                                    <div className="org-full-name">
                                                        <h4>{data.category}</h4>
                                                    </div>
                                                </td>
                                                <td className="mccDescription">
                                                    <div className="org-full-name">
                                                        <h4>
                                                            {data.description}
                                                        </h4>
                                                    </div>
                                                </td>
                                                <td className="mccType">
                                                    <div className="org-full-name">
                                                        <h4>
                                                            {data.risk
                                                                ? data.risk ==
                                                                  "low_risk"
                                                                    ? "Low Risk"
                                                                    : "High Risk"
                                                                : "-"}
                                                        </h4>
                                                    </div>
                                                </td>
                                                <td className="addresidual template-add-delete">
                                                    <span
                                                        onClick={(evt) => {
                                                            this.editRecord(
                                                                data,
                                                            );
                                                        }}
                                                    >
                                                        Edit
                                                    </span>
                                                    <span
                                                        onClick={(evt) =>
                                                            this.handleMccDelete(
                                                                data,
                                                            )
                                                        }
                                                        className="addresidualIMG"
                                                    >
                                                        <img src="/images/delet.svg " />
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={Math.ceil(
                                        this.state.totalMcc / 10,
                                    )}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    activeClassName={"active"}
                                    forcePage={this.state.page - 1}
                                />
                            </div>
                        ) : !this.state.showSpinner ? (
                            <p className="no-data text-center">
                                {" "}
                                No Record found
                            </p>
                        ) : (
                            ""
                        )}
                    </div>
                    {this.state.showSpinner ? (
                        <div className="mcc-loader">
                            <Loader />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    }
}

export default MccList;
